import Signin from "../../components/Signin";
function SigninPage() {
  return <Signin />;
}

export default SigninPage;
